module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"h1":"Профиль пользователя","h2":"Мы просим заполнить эту форму один раз, для уточнения ваших регистрационных данных"}}')
  delete Component.options._Ctor
}
